// Sub-nav for the Quality Signals admin area: Reports feed ⇄ Constellations ⇄
// Needs review (the learning-loop queue). Common Threads is hidden for now —
// it is superseded by Constellations and pending a messaging/accuracy cleanup
// (its route/page still exist and are reachable directly by URL).

import { Link, useLocation } from 'react-router-dom';
import styles from './SignalsTabs.module.css';

export function SignalsTabs() {
  const { pathname } = useLocation();
  const onConstellations = pathname.startsWith('/signals/constellations');
  const onReview = pathname.startsWith('/signals/review');
  const onBank = pathname.startsWith('/signals/bank');
  const onDigest = pathname.startsWith('/signals/digest');
  const onReports = !onConstellations && !onReview && !onBank && !onDigest;
  return (
    <nav className={styles.tabs}>
      <Link
        to="/signals"
        className={`${styles.tab} ${onReports ? styles.active : ''}`}
      >
        Reports
      </Link>
      <Link
        to="/signals/constellations"
        className={`${styles.tab} ${onConstellations ? styles.active : ''}`}
      >
        Constellations <span className={styles.beta}>new</span>
      </Link>
      <Link
        to="/signals/review"
        className={`${styles.tab} ${onReview ? styles.active : ''}`}
      >
        Needs review <span className={styles.beta}>new</span>
      </Link>
      <Link
        to="/signals/bank"
        className={`${styles.tab} ${onBank ? styles.active : ''}`}
      >
        Bank health <span className={styles.beta}>new</span>
      </Link>
      <Link
        to="/signals/digest"
        className={`${styles.tab} ${onDigest ? styles.active : ''}`}
      >
        My watches
      </Link>
    </nav>
  );
}
